import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { ActivePlanComponent } from 'src/app/start-workout/active-plan/active-plan/active-plan.component';

const routes: Routes = [
  {
    path: 'share/:planId',
    loadChildren: () =>
      import('./share/share.module').then((m) => m.SharePageModule),
  },
  {
    path: 'active-plan',
    loadChildren: () =>
      import('./start-workout/active-plan/active-plan.module').then(
        (m) => m.ActivePlanPageModule
      ),
  },
  {
    path: '',
    loadChildren: () =>
      import('./tabs/tabs.module').then((m) => m.TabsPageModule),
  },
  {
    path: 'start-workout',
    loadChildren: () =>
      import('./start-workout/start-workout.module').then(
        (m) => m.StartWorkoutPageModule
      ),
  },
  {
    path: '**',
    redirectTo: 'start-workout',
    pathMatch: 'full',
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
